import { render, staticRenderFns } from "./PropertyBoard.vue?vue&type=template&id=fb555382&scoped=true"
import script from "./PropertyBoard.vue?vue&type=script&lang=js"
export * from "./PropertyBoard.vue?vue&type=script&lang=js"
import style0 from "./PropertyBoard.vue?vue&type=style&index=0&id=fb555382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb555382",
  null
  
)

export default component.exports